const escapeHTML = (value = '') =>
  String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

const formatMoney = (value, currency) => {
  const numericValue = Number.parseFloat(String(value).replace(/[^0-9.-]/g, ''));
  if (!Number.isFinite(numericValue)) return escapeHTML(value);

  return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
    style: 'currency',
    currency: currency || 'INR',
    maximumFractionDigits: 0,
  }).format(numericValue);
};

const getProductImage = (product) => {
  if (typeof product.image === 'string') return product.image;
  return product.image?.url || product.featured_image?.url || product.featured_image || '';
};

const createCard = (product, currency) => {
  const image = getProductImage(product);
  const price = formatMoney(product.price, currency);
  const compareAtPrice = product.compare_at_price ? formatMoney(product.compare_at_price, currency) : '';
  const showComparePrice = compareAtPrice && compareAtPrice !== price;

  return `
    <div class="resource-list__item" data-recent-product-id="${escapeHTML(product.id)}">
      <a class="smart-recent-card" href="${escapeHTML(product.url)}">
        <span class="smart-recent-card__media">
          ${image ? `<img src="${escapeHTML(image)}" alt="${escapeHTML(product.title)}" loading="lazy" width="600" height="750">` : ''}
        </span>
        <p class="smart-recent-card__title">${escapeHTML(product.title)}</p>
        <span class="smart-recent-card__price">
          <span>${price}</span>
          ${showComparePrice ? `<span class="smart-recent-card__compare-price">${compareAtPrice}</span>` : ''}
        </span>
      </a>
    </div>`;
};

const loadRecentlyViewed = async (section) => {
    const list = section.querySelector('[data-recently-viewed-list]');
    if (!list) return;

    let viewedIds = [];
    try {
      viewedIds = JSON.parse(localStorage.getItem('viewedProducts') || '[]').map(String);
    } catch (_error) {
      viewedIds = [];
    }

    const currentId = String(section.dataset.currentProductId || '');
    const excludedIds = new Set(
      String(list.dataset.excludedProductIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
    );
    const maxProducts = Number.parseInt(section.dataset.maxProducts || '4', 10);
    viewedIds = viewedIds.filter((id) => id !== currentId && !excludedIds.has(id)).slice(0, maxProducts);

    if (!viewedIds.length) {
      list.innerHTML = '';
      list.dataset.hasRecommendations = 'false';
      section.hidden = true;
      return;
    }

    const url = new URL(`${window.Shopify?.routes?.root || '/'}search/suggest.json`, window.location.origin);
    url.searchParams.set('q', viewedIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', String(maxProducts));

    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Recently viewed request failed: ${response.status}`);
      const payload = await response.json();
      const products = payload?.resources?.results?.products || [];
      const byId = new Map(products.map((product) => [String(product.id), product]));
      const orderedProducts = viewedIds.map((id) => byId.get(id)).filter(Boolean);

      if (!orderedProducts.length) {
        section.hidden = true;
        return;
      }

      list.innerHTML = orderedProducts.map((product) => createCard(product, section.dataset.currency)).join('');
      list.dataset.hasRecommendations = 'true';
    } catch (error) {
      console.warn(error);
      section.hidden = true;
    }
};

const initializeRecentlyViewed = (root = document) => {
  root.querySelectorAll('[data-smart-recommendations][data-source="recently_viewed"]').forEach((section) => {
    if (section.dataset.recentlyViewedInitialized) return;
    section.dataset.recentlyViewedInitialized = 'true';
    loadRecentlyViewed(section);
  });
};

initializeRecentlyViewed();
document.addEventListener('shopify:section:load', (event) => initializeRecentlyViewed(event.target));
